import { CategoryButton } from '@/fo/ui/category/button/base';

export const mockItems: CategoryButton[] = [
  {
    id: 1,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Продление молодости',
    color: '#582C83'
  },
  {
    id: 2,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Жирная кожа и несовершенства',
    color: '#00C389'
  },
  {
    id: 3,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Атопический дерматит',
    color: '#0077CF'
  },
  {
    id: 4,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Розацеа и чувствительность',
    color: '#E0457B'
  },
  {
    id: 5,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Сухая кожа',
    color: '#00BBDC'
  },
  {
    id: 6,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Пигментация',
    color: '#98A4AE'
  },
  {
    id: 7,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Солнце',
    color: '#FFB600'
  },
  {
    id: 8,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Уход за лицом',
    color: '#64A8D8'
  },
  {
    id: 9,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Уход за телом',
    color: '#ABC5CF'
  },
  {
    id: 10,
    image: 'https://placeholder.pagebee.io/api/plain/200/200',
    link: '/',
    title: 'Дети',
    color: '#E6B5D0'
  }
];
